import { Roles } from 'consts/authConsts'
import useAccountOwnerId from 'hooks/useAccountOwnerId'
import useQueryParams from 'hooks/useQueryParams'
import { isUserOfRole } from 'utils/authUtils'

const CopilotOverrideRoles = [Roles.DevAdmin, Roles.HI, Roles.HIAdmin, Roles.Sales, Roles.Admin]

/**
 * Whether the signed-in user is an internal user viewing another practice's Copilot reports
 * through `?copilotDoctorId=`. The report guards and plan checks skip such a session because the
 * plan and flags they read belong to the internal user, not to the practice being viewed.
 */
export const isCopilotDoctorOverride = queryParams =>
  !!queryParams?.copilotDoctorId && isUserOfRole(CopilotOverrideRoles)

// Groups AppSync lets read any practice's PatientSearchModel; every patient list on the reports needs it.
const PatientSearchReaderRoles = [Roles.Admin, Roles.GI, Roles.HIAdmin]

/**
 * Whether the reports may show patient lists. A Sales user outside those groups can open another
 * practice's reports for the totals (GR-10771), but its patient searches would be denied.
 */
export const useCanViewCopilotPatients = () => {
  const { queryParams } = useQueryParams()

  return !(
    isCopilotDoctorOverride(queryParams) &&
    isUserOfRole([Roles.Sales]) &&
    !isUserOfRole(PatientSearchReaderRoles)
  )
}

export default () => {
  const { queryParams } = useQueryParams()

  const fallbackAccountOwnerId = useAccountOwnerId()
  const accountOwnerId = isCopilotDoctorOverride(queryParams) ? queryParams.copilotDoctorId : fallbackAccountOwnerId

  return accountOwnerId
}
